import { render, staticRenderFns } from "./callbackTaskOngoing.vue?vue&type=template&id=a87df02e&scoped=true&"
import script from "./callbackTaskOngoing.vue?vue&type=script&lang=js&"
export * from "./callbackTaskOngoing.vue?vue&type=script&lang=js&"
import style0 from "./callbackTaskOngoing.vue?vue&type=style&index=0&id=a87df02e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87df02e",
  null
  
)

export default component.exports